import {
  hasAdminPrivileges as sharedHasAdminPrivileges,
  canManageOrganization as sharedCanManageOrganization,
  hasOrganizationAccess,
  type TUser,
  type TUserRole,
  type UserRole
} from "@libs/shared-permissions";

export { hasOrganizationAccess, type TUser, type TUserRole, type UserRole };

export const hasAdminPrivileges = (role: string | undefined, organizationId = 0): boolean => {
  if (!role) return false;
  return sharedHasAdminPrivileges({ role: role as TUserRole, organizationId });
};

export const canManageOrganization = (role: string | undefined, organizationId?: number): boolean => {
  if (!role) return false;
  return sharedCanManageOrganization(
    { role: role as TUserRole, organizationId: organizationId || 0 },
    organizationId || 0
  );
};

export const isSystemAdmin = (role: string | undefined): boolean => {
  return role === "systemAdmin";
};
